'use client';

import styled from 'styled-components';

import { breakpoints, colors } from '@/styles/theme';

export const Container = styled.section`
  display: flex;
  justify-content: space-between;

  width: 100%;
  max-width: 1320px;
  gap: 96px;

  & a {
    text-decoration: underline;
  }

  .mantine-Accordion-root {
    width: 100%;
    min-width: 800px;
  }

  .mantine-Accordion-label {
    font-size: 1.1rem;
    font-weight: 600;

    @media (max-width: ${breakpoints.laptop}) {
      font-size: 0.9rem;
    }

    @media (max-width: ${breakpoints.mobile}) {
      font-size: 0.8rem;
    }
  }

  .mantine-Accordion-content {
    font-size: 1.1rem;

    @media (max-width: ${breakpoints.laptop}) {
      font-size: 1rem;
    }

    @media (max-width: ${breakpoints.mobile}) {
      font-size: 0.8rem;
    }
  }

  .mantine-Accordion-item {
    border: 1px solid ${colors.blue};

    @media (max-width: ${breakpoints.mobile}) {
      margin: 10px 0;
    }
  }

  @media (max-width: ${breakpoints.desktop}) {
    flex-direction: column;
    gap: 0;

    .mantine-Accordion-root {
      min-width: 100%;
    }
  }

  @media (max-width: 1320px) {
    max-width: 936px;
  }

  @media (max-width: 936px) {
    max-width: 618px;
  }
`;

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;

  gap: 16px;
`;

export const ContactMessage = styled.div`
  letter-spacing: 0.3px;
  width: 100%;

  @media (max-width: ${breakpoints.laptop}) {
    font-size: 0.9rem;
  }

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 0.8rem;
    padding: 5px 0;
  }

  > a {
    font-weight: 600;
    text-decoration: underline;
  }
`;
